import { memo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Stack, Tooltip, Typography } from '@lyearn/ui';
import { getTaskLinkedToInfo } from '@/modules/tasks/views/TasksDashboard/components/TaskDetails/components/TaskDetailsSidebar/components/TaskLinkedEntities/utils';

import { useActionItemContext } from '../../context';
import useHovered from '../../hooks/useHovered';

const TOOLTIP_CLASSES = { tooltip: 'rounded py-16 ps-14 pe-12 max-w-[28.5rem]' };

const ActionItemLinkedTo = () => {
  const { t } = useTranslation(['Feedback']);
  const { actionItem, disableInteractiveTooltip = false } = useActionItemContext();
  const entities = getTaskLinkedToInfo(t, actionItem.linkedToEntities);
  const { hovered, onMouseMove } = useHovered();

  if (!entities.length) {
    return null;
  }

  const entity = entities[0];
  const { Icon, name } = entity;

  const LinkedToComp = (
    <Stack alignItems="center" className="group min-w-0" onMouseMove={onMouseMove}>
      <Icon className="h-20 w-20 flex-shrink-0 text-icon-secondary me-8 group-hover:text-icon-primary" />
      <Typography
        className="truncate group-hover:text-text-primary"
        color="text-text-secondary"
        variant="body-short-02">
        {name}
      </Typography>
      {entities.length > 1 ? (
        <>
          <Typography
            className="group-hover:text-text-primary"
            color="text-text-secondary"
            variant="body-short-02">
            ,
          </Typography>
          <Typography
            className="ms-4 group-hover:text-text-primary"
            color="text-text-secondary"
            variant="body-short-02">
            {`+${entities.length - 1}`}
          </Typography>
        </>
      ) : null}
    </Stack>
  );

  if (!hovered) {
    return LinkedToComp;
  }

  const tooltipMessage = () => {
    return (
      <Box className="space-y-16">
        {entities.map((entity) => (
          <Stack key={entity.id}>
            <entity.Icon className="h-16 w-16 flex-shrink-0 me-8" fillColorToken="icon-secondary" />
            <Typography color="text-text-white" variant="body-short-03">
              {entity.name}
            </Typography>
          </Stack>
        ))}
      </Box>
    );
  };

  return (
    <Tooltip
      classes={TOOLTIP_CLASSES}
      disableInteractive={disableInteractiveTooltip}
      placement="bottom"
      title={tooltipMessage()}>
      {LinkedToComp}
    </Tooltip>
  );
};

export default memo(ActionItemLinkedTo);
